import React from 'react'
import { GroupBase, OptionProps } from 'react-select'

import { promoColors } from 'sections/PromoSection/shared/constants'
import { CountryItem } from 'components/CountryPhoneInput/CountryPhoneInput'
import { TextPromo } from 'components/ui'
import { BaseOption } from 'shared/types/types'

import ArrowIcon from 'assets/img/shared/arrow3.svg?react'
import s from './CustomOption.module.scss'

export const CustomOption: React.FC<
  OptionProps<BaseOption<CountryItem>, false, GroupBase<BaseOption<CountryItem>>>
> = ({ data, innerRef, innerProps, isSelected }) => (
  <div
    ref={innerRef}
    {...innerProps}
    className={s.customOption}
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '16px',
      borderBottom: '1px solid #ECEFF4',
      cursor: 'pointer',
    }}
    onMouseEnter={(e) => {
      if (!isSelected) {
        e.currentTarget.style.backgroundColor = '#FAF2FF'
        e.currentTarget.style.color = promoColors.newBgPrimary
      }
    }}
    onMouseLeave={(e) => {
      if (!isSelected) {
        e.currentTarget.style.backgroundColor = 'transparent'
        e.currentTarget.style.color = 'inherit'
      }
    }}
    onMouseDown={(e) => {
      e.currentTarget.style.backgroundColor = '#EFDDFF'
      e.currentTarget.style.color = '#651CAD'
    }}
  >
    <img
      src={`/img/flags/${data.value.country}.png`}
      alt={data.value.label}
      style={{ width: '28px', height: '20px', marginRight: '8px' }}
    />
    <TextPromo fontFamily="ASLHauss" size="s16">
      {data.value.label}

      <span className={s.code}> +{data.value.value}</span>
    </TextPromo>
    {isSelected && <ArrowIcon style={{ marginLeft: 'auto', width: '20px', height: '20px' }} />}
  </div>
)
